import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import seloJuridico from "../public/selo-juridico.png";
import SeloSystems from "../components/SeloSystems";
import { useAuth } from "../context/AuthContext";
import { Button, Card, Field, Input } from "../components/ui";

const Login = () => {
    const navigate = useNavigate();
    const { login, loginAdmin } = useAuth();
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [erro, setErro] = useState(null);
    const [carregando, setCarregando] = useState(false);

    /**
     * Uma tela só para o escritório e para o administrador do sistema:
     * tenta como usuário de escritório (caso comum) e, se o e-mail não for
     * um e-mail válido, tenta como admin — que entra por login, não e-mail.
     */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro(null);
        setCarregando(true);

        const pareceEmail = email.includes("@");

        try {
            if (pareceEmail) {
                await login(email, senha);
                navigate("/inicio", { replace: true });
            } else {
                await loginAdmin(email, senha);
                navigate("/admin", { replace: true });
            }
        } catch (err) {
            const status = err.response?.status;
            if (status === 429 || status === 403) {
                setErro(err.response.data?.error);
            } else {
                setErro(pareceEmail
                    ? (err.response?.data?.error || "E-mail ou senha incorretos.")
                    : "Login ou senha incorretos.");
            }
        } finally {
            setCarregando(false);
        }
    };

    return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 28, padding: "32px 16px" }}>
            <Card as="form" className="elev-md" style={{ width: "100%", maxWidth: 380, gap: 16, padding: 28 }} onSubmit={handleSubmit}>
                <img src={seloJuridico} alt="" style={{ height: 130, width: "auto", margin: "0 auto" }} />

                <div style={{ textAlign: "center" }}>
                    <p className="text-muted" style={{ fontSize: 14.5, margin: 0 }}>
                        Gestão para escritórios de advocacia
                    </p>
                </div>

                <Field label="E-mail (ou login do administrador)">
                    <Input
                        type="text"
                        required
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Field>

                <Field label="Senha">
                    <Input
                        type="password"
                        required
                        autoComplete="current-password"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                    />
                </Field>

                {erro && <p className="erro">{erro}</p>}

                <Button type="submit" disabled={carregando} className="btn-block">
                    {carregando ? "Entrando..." : "Entrar"}
                </Button>

                <p className="text-muted" style={{ fontSize: 14.5, margin: 0, textAlign: "center" }}>
                    Ainda não tem conta? <Link to="/registro">Cadastre seu escritório</Link>
                </p>
            </Card>

            <SeloSystems />
        </div>
    );
};

export default Login;
